import React from 'react';
import './Blog.css';
import { useContent } from '../../contexts/ContentContext';

const Blog: React.FC = () => {
  const { content, isLoading } = useContent();

  if (isLoading || !content) return null;

  // Sort by ID descending (newest first)
  const blogPosts = [...content.blog.list].sort((a, b) => 
    parseInt(b.id) - parseInt(a.id)
  );
  
  return (
    <section id="blog" className="section">
      <h2 className="section-title">Blog</h2>
      <div className="blog-grid">
        {blogPosts.map((post) => (
          <div key={post.id} className="blog-card">
            <div className="blog-image">
              <div className="blog-icon">{post.icon}</div>
              <div className="blog-date">{post.date}</div>
            </div>
            <div className="blog-content">
              <div className="blog-category-tag tech-tag">
                {post.category}
              </div>
              <a
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-title-link"
              >
                <h3 className="blog-title">{post.title}</h3>
              </a>
              <p className="blog-excerpt">{post.excerpt}</p>
              <div className="blog-meta">
                <div className="blog-tags">
                  {post.tags.map((tag, index) => (
                    <span key={index} className="blog-tag">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="blog-stats">
                  <span className="blog-likes">❤️ {post.stats.likes}</span>
                  <span className="blog-bookmarks">🔖 {post.stats.bookmarks}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog; 